import { BusinessCase, TEMPLATE_TYPES } from '@schuettflix/interfaces';
import { Trans, useTranslation } from 'react-i18next';
import { useSelectionTitle } from '../hooks/useSelectionTitle';

const TEMPLATE_NAME_LABEL = {
    FRANCO: 'template.name.franco',
    MERCHANT: 'template.name.merchant',
    STANDARD: 'template.name.standard',
} as const satisfies Record<TEMPLATE_TYPES, string>;

type BusinessCasePreviewProps = {
    businessCase: BusinessCase;
};

const descriptions = {
    FRANCO: 'productTemplateGroup.description.franco',
    MERCHANT: 'productTemplateGroup.description.merchant',
} as const;

export function BusinessCasePreview({ businessCase }: BusinessCasePreviewProps) {
    const { t } = useTranslation();
    const selectionTitle = useSelectionTitle({ businessCase });

    const descriptionTranslationKey =
        businessCase.pricingStrategy !== 'STANDARD' ? descriptions[businessCase.pricingStrategy] : null;
    const description = descriptionTranslationKey ? t(descriptionTranslationKey) : null;

    return (
        <div>
            <h4 className="font-copy-md-strong mb-2">{selectionTitle}</h4>
            {!businessCase.isStandalone ? (
                <span className="font-copy-md">
                    <Trans
                        t={t}
                        i18nKey={TEMPLATE_NAME_LABEL[businessCase.pricingStrategy]}
                        components={{ type: <u /> }}
                    />
                </span>
            ) : null}
            {description && <span className="font-copy-md text-subdued">{description}</span>}
        </div>
    );
}
